import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface TruncatedCellProps {
  children: React.ReactNode;
  className?: string;
  /** Full text to show in tooltip. If omitted, uses children's text content */
  tooltipText?: string;
}

/**
 * Always shows a tooltip on hover for truncated table cell content.
 * Parent element should have a max-width set for truncation to work.
 */
export function TruncatedCell({ children, className, tooltipText }: TruncatedCellProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn("block truncate", className)}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-sm text-xs z-50 break-words">
        {tooltipText ?? children}
      </TooltipContent>
    </Tooltip>
  );
}
